var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg06IconAndroidDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,50.2584995h64c0-10.8677316-5.4188287-20.4684271-13.700638-26.2521469l6.8391905-6.8391739c.7836737-.7836903.7836737-2.0542783,0-2.8379354s-2.0542451-.7836571-2.8379188,0l-7.5345501,7.5345667c-4.4179796-2.3021752-9.4395525-3.6052607-14.7660837-3.6052607s-10.348104,1.3030855-14.7660837,3.6052607l-7.5345667-7.5345667c-.7836737-.7836571-2.0542451-.7836571-2.8379188,0-.7836571.7836571-.7836571,2.0542451,0,2.8379354l6.8392071,6.8392071C5.4188287,29.7900724,0,39.3907679,0,50.2584995ZM32,22.2559373c14.0836036,0,25.7723196,10.4514055,27.7181678,24.0051742H4.2818322c1.9458483-13.5537687,13.6345642-24.0051742,27.7181678-24.0051742Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.7110767,
    cy: 36.1329629,
    r: 3.9680233
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.2889067,
    cy: 36.1329629,
    r: 3.9680233
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06IconAndroidDevelopment);
export default __webpack_public_path__ + "static/media/06-icon-android-development.8eb930181a5c4f75c1014f7254deaf01.svg";
export { ForwardRef as ReactComponent };